const initialState = {
  firstName: "",
  profilePicture: "",
  isRegistering: false,
  isLogged: false,
  mongoId: "",
  googleProvider: false,
};

export default initialState;
